/**
 * @generated SignedSource<<2f334c7434240e17c966186d31f143a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompaniesTableRow_company$data = {
  readonly id: string;
  readonly rowId: any;
  readonly name: string;
  readonly legalName: string | null;
  readonly createdAt: any;
  readonly deletedAt: any | null;
  readonly reports: {
    readonly totalCount: number;
    readonly nodes: ReadonlyArray<{
      readonly workflowSummary: any | null;
    }>;
  };
  readonly latestReports: {
    readonly nodes: ReadonlyArray<{
      readonly periodStart: any | null;
      readonly periodEnd: any | null;
    }>;
  };
  readonly " $fragmentType": "CompaniesTableRow_company";
};
export type CompaniesTableRow_company$key = {
  readonly " $data"?: CompaniesTableRow_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompaniesTableRow_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompaniesTableRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "legalName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportsConnection",
      "kind": "LinkedField",
      "name": "reports",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Report",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workflowSummary",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "latestReports",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CREATED_AT_DESC"
        }
      ],
      "concreteType": "ReportsConnection",
      "kind": "LinkedField",
      "name": "reports",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Report",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodStart",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodEnd",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reports(orderBy:\"CREATED_AT_DESC\")"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "05f313e2bfc3e3fe5f69bced7a0875b0";

export default node;
